import script from "./HistoryUsersList.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryUsersList.vue?vue&type=script&setup=true&lang=js"

import "./HistoryUsersList.vue?vue&type=style&index=0&id=29e940fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e940fa"]])

export default __exports__